import QuestionsMobileViewContainer from "./Containers/QuestionsMobileViewContainer";
export default QuestionsMobileViewContainer;
